import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SideBar from "./SideBar";
import { CV_DOWNLOAD_PATH, SHOW_CV_DOWNLOAD } from "../config/features";
import "./Frontpage.css";

const FrontPage = () => {
    const { t } = useTranslation();

    return (
        <div className="FrontPageContainer">
            <SideBar />
            <main className="MainContent">
                <h1>{t("home.name")}</h1>
                <h2>{t("home.role")}</h2>
                <hr />
                <p className="lead">{t("home.intro")}</p>
                <p>{t("home.supporting")}</p>
                <div className="callToActions">
                    <Link to="/experience">{t("home.viewExperience")}</Link>
                    <Link to="/skills">{t("home.viewSkills")}</Link>
                    <Link to="/contact">{t("home.contactMe")}</Link>
                    <a href="https://github.com/Janicxz" target="_blank" rel="noopener noreferrer">{t("home.viewGitHub")}</a>
                    {SHOW_CV_DOWNLOAD && (
                        <a href={CV_DOWNLOAD_PATH} download>{t("home.downloadCv")}</a>
                    )}
                </div>
            </main>
        </div>
    );
};
export default FrontPage;
